export interface Prices {
  id: string,
  displayValue: string
};

export interface Status {
  value: string,
  displayValue: string
};

export const subStatus: Status[] = [
  {displayValue: 'Tous', value: 'all'},
  {displayValue: 'Actif', value: 'active'},
  {displayValue: 'En retard', value: 'past_due'},
  {displayValue: 'Non payé', value: 'unpaid'},
  {displayValue: 'Annulé', value: 'canceled'},
  {displayValue: 'Incomplet', value: 'incomplete'},
  {displayValue: 'Incomplet expiré', value: 'incomplete_expired'},
  {displayValue: 'Essai', value: 'trialing'},
  {displayValue: 'Terminé', value: 'ended'}
];

export interface FiltersInterface {
  customer?: string,
  price?: string,
  status?: string
}